import http from '../../../../utils/andromeda-api';

export const fetchOpenEventsData = async ({ messageId, search, orgId }) => {
  const {
    data: { data },
  } = await http.get('/events/getMessageOpenEvents', {
    params: { messageId, search, orgId },
  });

  return data;
};
